import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController'
import { ButtonAPI, ImageAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import ConfigurationService from '../../services/configuration-services';
import { LayoutData } from '../../app/types';

@Controller({ fragment: 'reset-password-request-success', component: 'success-layout' })
class ResetPasswordRequestSuccessController extends BaseController {

  @Inject('title-image')
  imageHeader: ImageAPI;

  @Inject('ok-button')
  loginButton: ButtonAPI;

  @OnMount({ target: ['success-layout'] })
  onMount(): void {
    const { imageHeader } = this;
    ConfigurationService.getConfigurationData().then((layoutData: LayoutData) => {
      imageHeader.setSrc(layoutData.dsUrlLogoHeader);
    });
  }
  @OnClick({ target: 'ok-button' })
  onClickLoginButton(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

}

export default ResetPasswordRequestSuccessController;
